import { render } from "./BankBook.vue?vue&type=template&id=b4659ff8&scoped=true"
import script from "./BankBook.vue?vue&type=script&lang=js"
export * from "./BankBook.vue?vue&type=script&lang=js"

import "./BankBook.vue?vue&type=style&index=0&id=b4659ff8&scoped=true&lang=css"

import exportComponent from "D:\\xampp7\\htdocs\\24x7pos\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b4659ff8"]])

export default __exports__